import { Component, EventEmitter, Input, OnInit, Output, OnChanges, SimpleChanges } from '@angular/core';

import { LoggerService } from 'src/shared/logger/logger.service';
import { Levels } from 'src/shared/logger/levels.enum';
import { endpoint } from '../shared/endpoints.model';
import { SystemProfileService } from 'src/system-profile-manager/shared/system-profile-V2.service';

@Component({
  selector: 'app-system-V2',
  templateUrl: './system-profile-V2.component.html',
  styleUrls: ['./system-profile-V2.component.css'],
  providers: [SystemProfileService]
})
export class SystemProfileV2Component implements OnInit, OnChanges {

  @Input() tree_received_endpoint_data: any;
  @Input() selected_parent_folder: any;
  @Input() selected_folder: any;
  @Output() endPoint_location_updated = new EventEmitter<string>();
  endpoint_data: endpoint;
  adminAuthorization: boolean;

  constructor(private loggerService: LoggerService,
    private systemService: SystemProfileService) {
  }


  ngOnInit(): void {
    this.systemService.endpointDateToBeTransmitted.subscribe(data => this.endpoint_data = data);
    this.adminAuthorization = this.systemService.adminAuthorization
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.tree_received_endpoint_data?.item) {
      this.tree_received_endpoint_data.item.enable_phonebook = this.tree_received_endpoint_data.item.enable_phonebook == '1' ? "On" : "Off"
      this.tree_received_endpoint_data.item.enable_sip = this.tree_received_endpoint_data.item.enable_sip == '1' ? "On" : "Off"
      this.tree_received_endpoint_data.item.enable_h323 = this.tree_received_endpoint_data.item.enable_h323 == '1' ? "On" : "Off"
      this.systemService.endpointDateToBeTransmitted.next(this.tree_received_endpoint_data.item);
    } else {
      // those 2 lines were closed due to the move folder bug conflict with folder systems
      // this.tree_received_endpoint_data = null;
      // this.systemService.endpointDateToBeTransmitted.next(null);
    }

  }
  informParentToRefetchData(data) {
    this.endPoint_location_updated.emit(data);

  }

}
